import React from 'react';
import { Home, Tent, Trees } from 'lucide-react';

const USE_CASES = [
  {
    eyebrow: 'Backyard',
    title: 'Garden & yard',
    body: 'Branch trimming, hedge clearing, invasive vine removal, composting prep. Replace multiple garden tools with one.',
    image: '/images/use-garden.webp',
    Icon: Home,
  },
  {
    eyebrow: 'Outdoors',
    title: 'Camping & trails',
    body: 'Clear campsites, process firewood kindling, cut trail brush, prepare shelters. The ultimate one-tool camping solution.',
    image: '/images/use-camping.webp',
    Icon: Tent,
  },
  {
    eyebrow: 'Property',
    title: 'Land clearing',
    body: 'Fence line maintenance, overgrown lot clearing, saplings and brush removal. Keep your property clean and accessible.',
    image: '/images/use-land.webp',
    Icon: Trees,
  },
];

const DeployedSection: React.FC = () => {
  return (
    <section className="bg-forge text-paper py-24 lg:py-32 relative">
      <div className="max-w-editorial mx-auto px-6 lg:px-10">

        {/* Section header */}
        <div className="flex flex-col md:flex-row justify-between md:items-end gap-6 mb-16 lg:mb-20 border-b border-paper/15 pb-10">
          <div>
            <p className="font-mono text-[11px] tracking-micro uppercase text-ember-soft mb-6">
              — Everyday applications
            </p>
            <h2 className="font-editorial italic font-light text-4xl lg:text-5xl text-paper-warm leading-[1.05] tracking-tight">
              One tool.<br/>
              <span className="text-paper/85">Endless uses.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2 text-paper/55">
            <Trees className="w-4 h-4" strokeWidth={1.5} />
            <span className="font-mono text-[11px] tracking-micro uppercase">Real-world solutions</span>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {USE_CASES.map(({ eyebrow, title, body, image, Icon }, i) => (
            <article
              key={title}
              className={`relative group overflow-hidden aspect-[3/4] border border-paper/10 ${
                i === 1 ? 'md:mt-12' : ''
              }`}
            >
              <img
                src={image}
                alt={title}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ease-editorial"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-forge-deep via-forge-deep/30 to-transparent" />

              <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8">
                <div className="flex items-center gap-2 mb-4">
                  <Icon className="w-3.5 h-3.5 text-ember-soft" strokeWidth={1.5} />
                  <span className="font-mono text-[10px] tracking-micro uppercase text-ember-soft">
                    {eyebrow}
                  </span>
                </div>
                <h3 className="font-editorial italic text-2xl text-paper-warm mb-3 tracking-tight">
                  {title}.
                </h3>
                <p className="text-sm text-paper/65 leading-relaxed">{body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DeployedSection;
